<div class="container" style="margin-left:0;margin-right:0;">
  <form name="tableItemEditForm" #tableItemEditForm="ngForm" *ngIf="isCommonDataLoaded">
    <fieldset [disabled]="validacaoRLIndeferida()">
      <person-type [(cardData)]="personType"
                   [dropdowns]="dropdowns"
                   [yesNo]="yesNo"></person-type>

      <benefit-type [(cardData)]="benefitType" [yesNo]="yesNo"
                    [hasLegalRepresentation]="item.hasLegalRepresentation"
                    [stateRL]="item.stateRL"
                    [itemList]="itemList" [beneficiaryIdentification]="beneficiaryIdentification"></benefit-type>

      <beneficiary-identification [(cardData)]="beneficiaryIdentification"
                                  [personTypologyCode]="personType.personTypologyCode"
                                  [nationalities]="nationalities"
                                  [genders]="genders"
                                  [beneficiaryID]="item.beneficiaryID"
                                  [documentTypes]="documentTypes"
                                  [hasLegalRepresentation]="item.hasLegalRepresentation"
                                  [stateRL]="item.stateRL"
                                  [yesNo]="yesNo"
                                  [dropdowns]="dropdowns"></beneficiary-identification>

      <beneficiary-contacts [(cardData)]="beneficiaryContacts"
                            [beneficiaryID]="item.beneficiaryID"
                            [personTypologyCode]="personType.personTypologyCode"
                            [hasLegalRepresentation]="item.hasLegalRepresentation"
                            [stateRL]="item.stateRL"
                            [countries]="countries"></beneficiary-contacts>

      <deceased-relationship [(cardData)]="deceasedRelationship"
                             [hasLegalRepresentation]="item.hasLegalRepresentation"
                             [stateRL]="item.stateRL"
                             [benefitType]="benefitType"
                             [beneficiaryIdentification]="beneficiaryIdentification">

      </deceased-relationship>

      <legal-representation-identification [(cardData)]="legalRepresentationIdentification"
                                           [hasLegalRepresentation]="item.hasLegalRepresentation"
                                           [stateRL]="item.stateRL"
                                           [isServiceOrFunerary]="isServiceOrFunerary"
                                           [yesNo]="yesNo"></legal-representation-identification>

      <tax-information [(cardData)]="taxInformation" [personTypologyCode]="personType.personTypologyCode"
                       [benefitType]="benefitType"
                       [fiscalCategories]="fiscalCategories"
                       [hasLegalRepresentation]="item.hasLegalRepresentation"
                       [stateRL]="item.stateRL"
                       [incomeHoldings]="incomeHoldings"></tax-information>

      <payment [(cardData)]="payment" [bankAccountTypes]="bankAccountTypes"
               [hasLegalRepresentation]="item.hasLegalRepresentation"
               [stateRL]="item.stateRL"
               [yesNo]="yesNo" [countryCode]="beneficiaryContacts.countryCode"></payment>

      <beneficiary-observations [(cardData)]="beneficiaryObservations"
                                [hasLegalRepresentation]="item.hasLegalRepresentation"
                                [stateRL]="item.stateRL"></beneficiary-observations>

      <notifications [(cardData)]="notifications"
                     [beneficiaryID]="item.beneficiaryID"
                     [hasLegalRepresentation]="item.hasLegalRepresentation"
                     [stateRL]="item.stateRL"></notifications>
    </fieldset>
  </form>
  <div class="d-flex justify-content-between mt-4 mb-2">

    <button type="button" class="btn btn-outline-primary disable-on-fieldset" [disabled]="true" (click)="removeFromList(itemList,$event)" >
      <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span><span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
    </button>
    <button type="button" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)">
      <span class="icon-check"></span><span>Aplicar</span>
    </button>
  </div>

</div>
